import { summarizeBashCommand } from './shared/summarizeBashCommand';
import {
  enrichForgeDiscoveryGetProject,
  enrichForgeDiscoveryGetSkill,
  enrichForgeDiscoveryListSkills,
} from './shared/enrichForgeDiscoveryToolCall';
import { enrichForgeFilesystemToolCall } from './shared/enrichForgeFilesystemToolCall';

type ToolCallInput = {
  readonly input?: unknown;
};

function getInputCommand(toolCall: ToolCallInput): unknown {
  const input = toolCall.input;
  if (typeof input !== 'object' || input === null || !('command' in input)) {
    return undefined;
  }
  return (input as { command: unknown }).command;
}

/**
 * Adds `bashCommandSummary` for forge-bash run tool-call i18n templates.
 */
export function enrichForgeBashRunContext(toolCall: ToolCallInput): Record<string, unknown> {
  const summary = summarizeBashCommand(getInputCommand(toolCall));
  if (summary === undefined) {
    return {};
  }
  return { bashCommandSummary: summary };
}

export const mcpServerManagerToolCallEnrichers: Record<
  string,
  (toolCall: ToolCallInput) => Record<string, unknown>
> = {
  'forge-filesystem': enrichForgeFilesystemToolCall,
  'forge-bash__run': enrichForgeBashRunContext,
  'forge-discovery__get_project': enrichForgeDiscoveryGetProject,
  'forge-discovery__list_skills': enrichForgeDiscoveryListSkills,
  'forge-discovery__get_skill': enrichForgeDiscoveryGetSkill,
};
